import { makeStyles } from "@material-ui/core";

const useRbChipListStyles = makeStyles(() => ({
  root: {
    listStyle: "none",
    margin: "-4px 0 0 -4px",
    padding: 0,
  },
  chip: {
    marginTop: 4,
    marginLeft: 4,
  },
}));

export default useRbChipListStyles;
